import { TemplatePage } from './types';

const live_streaming_medical_theme: TemplatePage = {
  header: {
    color: '#FCDADB',
    icon: 'images/video-templates/healtcare-pharma.jpg',
    title: 'Live Stream Templates — Medical Theme',
    title_meta: 'Free Live Stream Overlay Templates — Medical Theme',
    description_meta:
      'Make your live streams appear more professional and visually appealing with Wave.video’s easily' +
      ' editable medical-themed overlay templates.',
    description:
      'Make your live streams appear more professional and visually appealing with our collection' + 
      ' of easily editable medical-themed overlay templates. Create on-brand overlays, intros & outros,' +
      ' thumbnails, and lower thirds in a matter of minutes.'
  },
  footer: {
    category: 'Live Stream Medical Theme',
    description:
      'Thanks to Wave.video’s packs of customizable templates for different industries and use cases,' +
      ' you can level up your live streams with no effort. Mesmerize your online audience with finger-stopping' +
      ' intros, outros, overlays, thumbnails, and lower thirds without hiring expensive video editors. Take' +
      ' your next big step towards becoming a highly successful live streamer!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Medical Theme',
      search: { name: 'MedicalTheme', tags: 'MedicalTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_medical_theme;
